const MXN = new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN", minimumFractionDigits: 2 });
const MONTHS = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];
const SHORT = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];

export const money = (n: number) => (n < 0 ? "−" : "") + MXN.format(Math.abs(n));

const PREFIX: Record<string, string> = { MXN: "$", USD: "US$", EUR: "€" };
const NUM = new Intl.NumberFormat("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const moneyIn = (n: number, cur: string = "MXN") => (cur === "MXN" ? money(n) : `${n < 0 ? "−" : ""}${PREFIX[cur] ?? cur + " "}${NUM.format(Math.abs(n))}`);
export const rateText = (r: number) => `$${r.toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 4 })}`;

export const signedMoney = (n: number, flow: "in" | "out" | "neutral") =>
  flow === "neutral" ? MXN.format(Math.abs(n)) : `${flow === "in" ? "+" : "−"}${MXN.format(Math.abs(n))}`;

export const wholeMoney = (n: number) => `${n < 0 ? "−" : ""}$${Math.round(Math.abs(n)).toLocaleString("es-MX")}`;

const pad = (n: number) => String(n).padStart(2, "0");

export const todayISO = () => {
  const d = new Date();
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

export const currentMonth = () => todayISO().slice(0, 7);

export const shiftMonth = (ym: string, delta: number) => {
  const [y, m] = ym.split("-").map(Number);
  const d = new Date(y, m - 1 + delta, 1);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}`;
};

export const monthName = (ym: string) => MONTHS[Number(ym.split("-")[1]) - 1];
export const monthLabel = (ym: string) => `${monthName(ym)} ${ym.split("-")[0]}`;
export const shortMonth = (ym: string) => SHORT[Number(ym.split("-")[1]) - 1];
export const formatDate = (iso: string) => `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}`;

export const formatDateTime = (iso: string) => {
  const d = new Date(iso);
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
};

export const initials = (name: string) =>
  name.split(/\s+/).filter(Boolean).map((p) => p[0]).slice(0, 2).join("").toUpperCase();
